import { Accept } from "react-dropzone";
import { MediaPurpose } from "../hooks/api/types";

export const ACCEPT_PDF_OBJ: Accept = { "application/pdf": [".pdf"] };

export const ACCEPT_ALL_DOCUMENTS_OBJ: Accept = {
  "application/pdf": [".pdf"],
  "application/msword": [".doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
  "application/vnd.ms-powerpoint": [".ppt"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
    ".pptx",
  ],
  "image/gif": [".gif"],
  "text/plain": [".txt"],
  "image/jpeg": [".jpg", ".jpeg", ".pjpeg"],
  "image/png": [".png"],
  "image/heic": [".heic"],
};

export const ACCEPT_IMAGES_OBJ: Accept = {
  "image/gif": [".gif"],
  "image/jpeg": [".jpg", ".jpeg", ".pjpeg"],
  "image/png": [".png"],
  "image/heic": [".heic"],
};

export function getDropzoneAcceptForPurpose(purpose: MediaPurpose): Accept {
  switch (purpose) {
    case MediaPurpose.TRADE_LICENSE:
      return ACCEPT_PDF_OBJ;
    case MediaPurpose.VAT_CERTIFICATE:
      return ACCEPT_PDF_OBJ;
    case MediaPurpose.BANK_STATEMENT:
      return ACCEPT_PDF_OBJ;
    case MediaPurpose.VENDOR_TRADE_LICENSE:
      return ACCEPT_PDF_OBJ;
    default:
      return ACCEPT_ALL_DOCUMENTS_OBJ;
  }
}

export const ACCEPT_PDF_STR = ".pdf,application/pdf";
export const ACCEPT_IMAGES_STR = ".jpg,.jpeg,.png,.heic,.pjpeg,.gif";
export const ACCEPT_ALL_DOCUMENTS_STR =
  ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.jpg,.jpeg,.png,.heic,.pjpeg,.gif";

export function getInputAcceptForPurpose(purpose: MediaPurpose): string {
  switch (purpose) {
    case MediaPurpose.TRADE_LICENSE:
      return ACCEPT_PDF_STR;
    case MediaPurpose.VAT_CERTIFICATE:
      return ACCEPT_PDF_STR;
    case MediaPurpose.BANK_STATEMENT:
      return ACCEPT_PDF_STR;
    // Image-only purposes
    case MediaPurpose.EMIRATES_ID_FRONT:
    case MediaPurpose.EMIRATES_ID_BACK:
    case MediaPurpose.PASSPORT:
    case MediaPurpose.FACE_ID:
    case MediaPurpose.SIGNATURE:
    case MediaPurpose.SIGNATURE_STROKE:
      return ACCEPT_IMAGES_STR;
    default:
      return ACCEPT_ALL_DOCUMENTS_STR;
  }
}

// Build a user-facing extensions hint for Dropzone based on purpose and max size (MB)
export function getExtensionsHintForPurpose(
  purpose: MediaPurpose,
  maxSizeMB: number
): string[] {
  const acceptMap = getDropzoneAcceptForPurpose(purpose);
  const allowedExts = Array.from(
    new Set(
      Object.values(acceptMap || {})
        .flat()
        .map((ext: string) => ext.replace(".", "").toUpperCase())
    )
  );
  return [
    allowedExts.length ? allowedExts.join(", ") : undefined,
    `Maximum file size is ${maxSizeMB} MB`,
  ].filter(Boolean) as string[];
}
